module.exports = __webpack_public_path__ + "056fbdd4eb033031d84001a64939596e.svg";